export default __webpack_public_path__ + "static/media/cyberSecurity.d7186ff7.svg";